<template><ArticlePage page="install" :content="content" /></template>
<script>
import ArticlePage from '@/components/ArticlePage.vue';
import content from '@/documents/content/install.js';
export default { name: 'Install', components: { ArticlePage }, data: () => ({ content }) };
</script>
